
  
   
    <div class="modal-header bg-light pb-0">
        <h4 id="modal-basic-title" class="modal-title">Update Batch price</h4>
        <button type="button" aria-label="Close" class="close" (click)="ActiveModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
        </button>
        </div>
    <hr>
        <div class="modal-body bg-light">
        <form>
        <div class="input-group mb-3">
        <label for="batchListingPrice">Set batch listing price to:</label>
        <div class="input-group border-1">
            <div class="input-group-prepend">
                <span class="input-group-text">&yen;</span>
              </div>
        <input name="price" (keypress)="checkPriceValidation($event)" id="batchListingPrice" type="text" class="form-control form-control-lg rounded-0" [(ngModel)]="price" appTwoDigitDecimaNumber preventCutCopyPaste #name="ngModel" required>
        <div class="input-group-append">
            <span class="input-group-text">per WMT</span>
          </div>
          <p *ngIf="price<100" class="text-danger text-center my-1 strong "> Listing price should be greater than 100</p>

        </div>
        </div>
        </form>
        </div>
        <hr>
        <div class="modal-footer bg-light" >
            <div class="form-group ">
         <button class="btn btn-light color-black btn-outline-dark mr-2  " type="button" data-dismiss="modal" (click)="ActiveModal.close('Close click')">Cancel</button>
         <button class="btn btn-primary " type="submit" (click)="updatePrice()" [disabled]="price<100">Save</button>
          </div>
        </div>
       
      
    
      
      
    

